import { LdButton, LdCard, LdLabel, LdNotice } from "@liquid/react";
import styled from "@emotion/styled";
import { ResultTableCustom } from "@src/components/ResultTable";

export const StyledIGVColumn: any = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  width: ${({ width }: any) => width}%;
`;

export const StyledResultContainer = styled(LdCard)`
  border: 1px solid #dfdfdf;
  background-color: var(--ld-col-wht);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const StyledResultTable = styled(ResultTableCustom)`
  width: 80%;
`;

export const StyledHightLightSpan = styled.span`
  color: rgb(55, 154, 69);
  background-color: #d2d5d2;
  font-family: monospace;
  letter-spacing: 2px;
`;

export const StyledDownload = styled(LdButton)`
  display: flex;
`;

export const StyledModalFooter = styled.div`
  text-align: center;
  width: 100%;
  margin: 0;
  padding-top: 15px;
  border-top: 1px solid #eae6e6;

  & ::part(button) {
    margin-left: 20px;
  }
`;

export const StyledBox = styled.div`
  display: grid;
  gap: 1rem;
  grid-template-columns: 180px auto;
  width: 100%;
  margin-bottom: 10px;
`;
export const StyledBoxLabel = styled(LdLabel)`
  align-items: center;

  span {
    font-size: 13px;
    color: #4c4a4a;
  }
`;
export const StyledBoxInput = styled.div<{ fullWidth?: boolean }>`
  display: grid;
  grid-template-columns: ${({ fullWidth }) => fullWidth ? "1fr" : "repeat(3, 1fr)"};
  column-gap: 10px;
  row-gap: 1em;
  width: ${({ fullWidth }) => fullWidth ? "100%" : "auto"};
`;

export const StyledNotice = styled(LdNotice)`
  margin-bottom: 1rem;
`;
